<div class="markets-capital mtb15" *ngIf="companies">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-6" *ngFor="let company of companies">
        <div class="markets-capital-item">
          <button mat-icon-button (click)="removeFav(company.SYMBOL_CODE)" color='danger' class="close-widget" style="margin-inline-end: 10px;">
            <mat-icon>close</mat-icon>
          </button>
          <div class="d-flex flex-column px-3 white-dark-smoke">
            <span style="font-weight: bold; text-align: start;">{{company.Reuters}}</span>
            <span style="text-overflow: ellipsis;text-align: start; white-space: nowrap; overflow: hidden; font-size: 13px;">{{(translate.currentLang=="en")?company.ENG_NAME:company.ARB_NAME}}</span>
          </div>
          <div class="d-flex flex-row justify-content-between px-3 pt-2">
            <span class="white-dark-smoke" style="font-size: 20px;">{{company.LAST_TRADE_PRICE| number: "1.2-3":"en-US"}}
              <span *ngIf="company.CURRENCY == 1" class="text-muted" style="font-size: 12px;">
                EGP
              </span>
              <span *ngIf="company.CURRENCY == 2" class="text-muted" style="font-size: 12px;">
                $
              </span>
            </span>
          </div>
          <div class="d-flex flex-row justify-content-between px-3">
            <span [ngClass]="company.LAST_CHANGE_PRC>0? 'green' : 'red'">{{company.LAST_CHANGE | number:'1.3'}} ({{company.LAST_CHANGE_PRC}})% <i class="ion-md-trending-up" *ngIf="company.LAST_CHANGE_PRC>0"></i>
              <i class="ion-md-trending-down" *ngIf="company.LAST_CHANGE_PRC<0"></i>
            </span>
          </div>
          <div class="markets-capital-chart" *ngIf="company">
            <canvas style="max-width: 100%;"></canvas>
          </div>
          <div class="d-flex flex-fill" style="position: relative;bottom: 0px;">
            <div style="width: 50%;">
              <button (click)="orderBuy(company,0)" style="width: 100%;border-radius: 0; background: rgb(38, 222, 130);" mat-flat-button>BUY</button>
            </div>
            <div style="width: 50%;">
              <button (click)="orderBuy(company,1)" style="width: 100%;border-radius: 0; background: rgb(255, 75, 62);" mat-flat-button>SELL</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
